import React, { useEffect, useState } from "react";

import MainScreen from "./templates/MainScreen";
import StatsTab from "../components/StatsTab";
import { LowerbarState } from "../../model/lowerBarState";
import { getListRanking } from "../../viewmodel/providers/list_scoreboard";
import Person from "../components/Person";
import { IconButton, List, ListItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, makeStyles } from "@material-ui/core";
import { AddShoppingCart, BorderAll, BorderTop, Star } from "@material-ui/icons";
import { PersonAdd } from "@material-ui/icons";
import routes from "../../utils/routes.json";
import apiRoutes from "../../utils/apiRoutes.json";
import api from "../../utils/api";
import { useProfile } from "../../viewmodel/hooks/getProfile";
import { UserContext } from "../../viewmodel/providers/user-context";
import PersonSimple from "../components/PersonSimple";


const useStyles = makeStyles((theme) => ({
    table: {
        width: "wrap",
        fontSize: "3rem !important"
    },
    td: {
        backgroundColor: "#fff",
        fontSize: "50px",
        padding: "8px",
        textAlign: "center",
        margin: "1rem",
    },
    th: {
        backgroundColor: "#fff",
        fontSize: "50px",
        padding: "8px",
        textAlign: "left",
    },
    blackButton: {
        backgroundColor: theme.palette.primary.main,
        width: "100%",
        "&:hover": {
            background: theme.palette.primary.main,
        },
    },
    marginButton: {
        margin: "20px 7%",
    },
    badge: {
        backgroundColor: "#FF5A00",
        borderRadius: "50%",
        color: "#fff",
    },
    bigBadge: {
        backgroundColor: "#FF5A00",
        borderRadius: "50%",
        color: "#fff",
        height: "30px",
        minWidth: "30px",
        fontSize: "20px",
    },
    fontSize: {
        fontSize: "3rem",
        ["@media (max-height: 1217px)"]: {
            fontSize: "2rem",
        },
        ["@media (max-height: 980px)"]: {
            fontSize: "1.5rem",
        },
        ["@media (max-height: 750px)"]: {
            fontSize: "1rem",
        },
        ["@media (max-width: 1000px)"]: {
            fontSize: "3rem",
        },
        ["@media (max-width: 600px)"]: {
            fontSize: "2rem",
        },
        ["@media (max-width: 390px)"]: {
            fontSize: "2rem",
        },
    },

    marginTop: {
        marginTop: "4rem",
    },

    firstplace: {
        fontSize: "6rem",
        color: "#FFD700",
        alignSelf:"center",
        ["@media (max-width: 1000px)"]: {
            fontSize: "6rem",
        },
        ["@media (max-width: 600px)"]: {
            fontSize: "3rem",
        },
        ["@media (max-width: 390px)"]: {
            fontSize: "2rem",
        },
    },

    secondplace: {
        fontSize: "5rem",
        color: "#C0C0C0",
        alignSelf:"center",
        ["@media (max-width: 1000px)"]: {
            fontSize: "5rem",
        },
        ["@media (max-width: 600px)"]: {
            fontSize: "2.5rem",
        },
        ["@media (max-width: 390px)"]: {
            fontSize: "2rem",
        },
    },

    thirdplace: {
        fontSize: "4rem",
        color: "#cd7f32",
        alignSelf:"center",
        ["@media (max-width: 1000px)"]: {
            fontSize: "4rem",
        },
        ["@media (max-width: 600px)"]: {
            fontSize: "2rem",
        },
        ["@media (max-width: 390px)"]: {
            fontSize: "2rem",
        },
    }
}));

export default function Stats(): JSX.Element {

    const [list, setList] = useState([])
    const classes = useStyles();
    const [friends, setState] = useState<any>([])
    const userId: string = React.useContext(UserContext).userId;

    useEffect(() => {
        getListRanking(setList);
    }, [])

    useEffect(() => {
        api.get(routes.friendsList)
            .then(response => {
                setState(response.data.data.FRIENDS.map((item: any) => item.id))
            });
    }, []);

    function addFriend(id: number) {
        api.post(apiRoutes.addFriend, { "friend_id": id }).then(() => {
            api.put("/add_friend", {
                user: id,
                message: JSON.stringify({ message: "Friend", "categoryIds": "" }),
            });
        })
    }


    return (
        <MainScreen lower={true} back={true} backPath={apiRoutes.menu} lowerBarState={LowerbarState.STATS}>
            <StatsTab />
            <TableContainer component={Paper} classes={{ root: `${classes.marginTop}`}}>
                <Table className={`${classes.table}`} size="medium" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell classes={{ root: classes.fontSize }} align="left">RANK</TableCell>
                            <TableCell classes={{ root: classes.fontSize }} align="left">NAME</TableCell>
                            <TableCell classes={{ root: classes.fontSize }} align="left"> FRIEND ?</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list.slice(0, 3).map((item: any, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row" classes={{ root: classes.fontSize }}>
                                    {index === 0 && <Star style={{ marginRight: '5px' }} classes={{ root: classes.firstplace}} />}
                                    {index === 1 && <Star style={{ marginRight: '5px' }} classes={{ root: classes.secondplace}}/>}
                                    {index === 2 && <Star style={{ marginRight: '5px' }} classes={{ root: classes.thirdplace}}/>}
                                </TableCell>
                                <TableCell align="left" classes={{ root: classes.fontSize }}>
                                    <React.Fragment>
                                        <PersonSimple id={item.id} key={index} personName={item.username} path={"#"}/>
                                    </React.Fragment>
                                </TableCell>
                                <TableCell align="left" classes={{ root: classes.fontSize }}>
                                    {userId !== item.id && !friends.includes(item.id) && (
                                        <IconButton color="primary" aria-label="personAdd" onClick={() => addFriend(item.id)}>
                                            <PersonAdd classes={{ root: classes.fontSize }} />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                        {list.slice(3).map((item: any, index) => (
                            <TableRow key={index}>
                                <TableCell component="th" scope="row" classes={{ root: classes.fontSize }}>
                                    {index + 4}
                                </TableCell>
                                <TableCell align="left" classes={{ root: classes.fontSize }}>{item.username}</TableCell>
                                <TableCell align="left" classes={{ root: classes.fontSize }}>
                                    {userId !== item.id && !friends.includes(item.id) && (
                                        <IconButton color="primary" aria-label="personAdd" onClick={() => addFriend(item.id)}>
                                            <PersonAdd classes={{ root: classes.fontSize }} />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </MainScreen>
    );
}
